import { Routes, Route, Outlet } from "react-router-dom";
import Home from "../pages/Home";
import ContactUs from "../pages/ContactUs";
import PartnerWithUs from "../pages/PartnerWithUs";
import RefundPolicy from "../pages/RefundPolicy";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermConditions from "../pages/TermConditions";
import BlogDetails from "../pages/BlogDetails";
import Blog from "../pages/Blog";
import Reviews from "../pages/Reviews";
import FaqPage from "../pages/FaqPage";
import Login from "../pages/auth/Login";
import Signup from "../pages/auth/Signup";
import LoginOTP from "../pages/auth/LoginOTP";
import SignupOTP from "../pages/auth/SignupOTP";
import BookingPage from "../pages/BookingPage";
import Checkout from "../pages/Checkout";
import Profile from "../pages/Profile";
import MyBookings from "../pages/MyBookings";
import BookingDetail from "../pages/BookingDetail";
import PaymentStatus from "../pages/PaymentStatus";
import EventBookingPage from "../pages/EventBookingPage";
import CorporateBookingPage from "../pages/CorporateBookingPage";
import PayBooking from "../pages/PayBooking";
import RideTracking from "../pages/RideTracking";
import DownloadApp from "../pages/DownloadApp";
import DownloadVendorApp from "../pages/DownloadVendorApp";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";

function MainLayout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/pay-booking/:encrypted_id" element={<PayBooking />} />
      <Route path="/track/:token" element={<RideTracking />} />
      <Route path="/download-app" element={<DownloadApp />} />
      <Route path="/download-vendor-app" element={<DownloadVendorApp />} />

      <Route element={<MainLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login-otp" element={<LoginOTP />} />
        <Route path="/signup-otp" element={<SignupOTP />} />

        <Route path="/booking/:type" element={<BookingPage />} />
        <Route path="/booking/:type/re-book/:id" element={<BookingPage />} />
        <Route path="/events" element={<EventBookingPage />} />
        <Route path="/corporate" element={<CorporateBookingPage />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/payment-status" element={<PaymentStatus />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/bookings" element={<MyBookings />} />
        <Route path="/booking-detail/:id" element={<BookingDetail />} />
        <Route path="/" element={<Home />} />
        <Route path="/faqs" element={<FaqPage />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/partner" element={<PartnerWithUs />} />

        <Route path="/blogs" element={<Blog />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/blog/:slug" element={<BlogDetails />} />
        <Route path="/term-conditions" element={<TermConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
      </Route>
    </Routes>
  );
}
